export const dashboard = '/';
export const login = '/login';
